import React from 'react';
import { CategoryBar, FeaturedGemstones } from '../components/home/CategoryStructure';
import { Hero } from '../components/home/Hero';
import { TrustMarquee } from '../components/home/TrustMarquee';
import { BestSellers } from '../components/home/BestSellers';
import { HotProducts } from '../components/home/HotProducts';
import { CombosSection } from '../components/home/CombosSection';
import { ShopByPurpose } from '../components/home/ShopByPurpose';
import { Categories } from '../components/home/Categories';
import { RecentlyViewed } from '../components/home/RecentlyViewed';
import { FreeToolsSection } from '../components/home/FreeToolsSection';
import { ProductOfDay } from '../components/home/ProductOfDay';
import { Testimonials } from '../components/home/Testimonials';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { FollowUs } from '../components/home/FollowUs';
import { SEO, pageSEO, organizationSchema, websiteSchema, storeSchema, remedyFAQs, generateFAQSchema } from '../components/SEO';

export default function HomePage() {
  // Combined schema for homepage including FAQ for remedies
  const faqSchema = generateFAQSchema(remedyFAQs);
  const homeSchema = [organizationSchema, websiteSchema, storeSchema, faqSchema];
  
  return (
    <div data-testid="home-page">
      <SEO 
        {...pageSEO.home}
        url="https://astrovasturemedies.in"
        schema={homeSchema}
      />
      
      {/* Category Navigation Bar - Above Hero */}
      <CategoryBar />
      
      {/* Hero Banner with Slideshow */}
      <Hero />
      
      {/* Trust Marquee - Scrolling Banner */}
      <TrustMarquee />
      
      {/* Hot Products - Featured Categories */}
      <HotProducts />
      
      {/* Best Sellers - Carousel */}
      <BestSellers />
      
      {/* Combo Deals Section */}
      <CombosSection />
      
      {/* Shop by Purpose */}
      <ShopByPurpose />
      
      {/* Shop by Category - all collections */}
      <Categories />
      
      {/* Featured Gemstones Section */}
      <FeaturedGemstones />
      
      {/* Recently Viewed Products */}
      <RecentlyViewed />
      
      {/* Featured Product of the Day */}
      <ProductOfDay />
      
      {/* Free Astrology Tools */}
      <FreeToolsSection />
      
      {/* Why Choose Us */}
      <WhyChooseUs />
      
      {/* Testimonials */}
      <Testimonials />

      {/* Follow Us on Social */}
      <FollowUs />
    </div>
  );
}
